import { ShowHiddenCondition, showHiddenOperator } from '../../types/control-show-hidden.types';

export function isShowConditionValue(condition: ShowHiddenCondition) {
  if (condition.op === showHiddenOperator.NotNull || condition.op === showHiddenOperator.Null) {
    return false;
  }
  return true;
}
